// date-utils.ts
import moment from 'moment';

export class DateUtils {
    // Converte um objeto Date em ticks
    static dateToTicks(date: Date): number {
        return date.getTime();
    }

    // Converte ticks em um objeto Date
    static ticksToDate(ticks: number): Date {
        return new Date(ticks);
    }

    // Converte um objeto Moment.js em ticks
    static momentDateToTicks(momentDate: moment.Moment): number {
        const jsTicks = momentDate.valueOf();
        const ticksPerMillisecond = 10000;
        const cSharpEpochTicks = 621355968000000000; // Ticks desde 1º de janeiro de 0001 até 1º de janeiro de 1970 (em 100 nanosegundos)

        const cSharpTicks = (jsTicks * ticksPerMillisecond) + cSharpEpochTicks;
        return cSharpTicks;
    }

    static dateToString(momentDate: moment.Moment): string {
        return moment(momentDate).format('YYYY-MM-DD');
    }

    static momentDateToString(date: Date): string | null {
        if (!date) return null;
        return moment(date).format('YYYY-MM-DD');
    }

    static getCurrentTime(): string {
        return moment().format('HH:mm');
    }
}
